import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { installAuthRefresh } from './utils/authUtils';

// Истёкший токен доступа обновляется сам при первом ответе 401.
installAuthRefresh();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
